import React, {useState, useEffect} from 'react'
import moment from 'moment'
import Isvg from 'react-inlinesvg'
import _ from "lodash"

import validationService, {IValidationErrors} from "data/validate"
import ConfirmationModal from "components/modal/confirmation-modal"
import { WithTip } from 'components/tooltip/with-tip'
import { parseErrorsToErrorTable, parseErrorsToText } from 'data/lib/validation'
import { ValidationErrorTable } from "components/modal/modal-styles"
import { DownloadIcon } from 'images/icons/tools'
import download from "data/lib/download"

const Download = onClick => (
  <WithTip position="bottom">
    <span>Download Validation Issues</span>
    <div id="downloadTooltipTarget" className="calc-download-icon" onClick={onClick}>
      <Isvg src={DownloadIcon}/>
    </div>
  </WithTip>
)

export const ValidationModal = (props) => {
  const [error, setError] = useState<IValidationErrors>({errordetail: {}, calcDetail: {errors: []}})
  const [show, setShow] = useState<boolean>(false)
  const onHide = () => validationService.hideValidationErrors()

  const {errordetail, calcDetail} = error
  const { items, header, calcItems } = parseErrorsToErrorTable(errordetail, calcDetail)

  useEffect(() => {
    const validationSubscription = validationService.stream().subscribe(errors => {
      let err = validationService.filteredValue()
      setError(err)
      setShow(!!err.show)
    })

    return function cleanup() {
      validationSubscription.unsubscribe()
    }
  }, [])

  const downloadErrors = () => {
    const filename = `input_issues_${moment().format('YYYY-MM-DD-HHmm')}.txt`
    let lines = []

    if (errordetail) {
      lines = _.concat(lines, 'Invalid or missing inputs in:', parseErrorsToText(errordetail))
    }
    if (calcDetail && calcDetail.errors && calcDetail.errors.length) {
      lines = _.concat(lines, '\rCalculation warnings:\r\n', calcDetail.errors.map(e => _.get(e, "error")))
    }
    download(filename, lines)
  }

  let body = [
    <table key="validation-error-table">
      {header}
      <tbody>{items}</tbody>
    </table>
  ]

  if (calcItems.items.length) {
    body.push(
      <table key="calc-error-table">
        {calcItems.header}
        <tbody>{calcItems.items}</tbody>
      </table>
    )
  }

  const title = ['Please review the following:', Download(() => downloadErrors())]

  return (
    <ConfirmationModal
      cancelFunc={onHide}
      toggleShow={onHide}
      confirmOnly={true}
      closeOnly={false}
      confirmFunc={onHide}
      message=""
      show={show}
      confirmText='Close'
      title={title}
      scrollY>
      <ValidationErrorTable>{ body }</ValidationErrorTable>
    </ConfirmationModal>
  )
}

export default ValidationModal
